import { loginClearError, storeUserMetadata } from '../store/login/login.actions';
import { loginComplete } from '../store/login/login.actions';
import { Login } from '../components/login';
import { retailerApi } from '@common/retailer-api';
const {
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const logger = svs.core.log.getLogger('welcome:LoginContainer');
export const LoginContainer = () => {
  const dispatch = useDispatch();
  const [getRetailerInfo, {
    data: retailerInfo,
    error: retailerInfoError
  }] = retailerApi.useLazyGetUserProfileQuery();
  const {
    hasStoredUserMetadata,
    isAuthenticated,
    isComplete,
    isMissingUserMetadata,
    error
  } = useSelector(({
    login
  }) => login);
  const hasToChangePassword = useSelector(({
    login
  }) => login.isComplete && login.mustChangePassword);
  const isIamFlow = new URLSearchParams(window.location.search).get('iam') === '1';
  const isIamErrorFlow = new URLSearchParams(window.location.search).get('iamLoginError') === '1';
  useEffect(() => {
    if (isAuthenticated && !isComplete) {
      getRetailerInfo();
    }
  }, [isAuthenticated, isComplete, getRetailerInfo]);
  useEffect(() => {
    if (retailerInfo) {
      dispatch(storeUserMetadata(retailerInfo));
    }
  }, [dispatch, retailerInfo, retailerInfoError]);
  useEffect(() => {
    if (hasStoredUserMetadata) {
      dispatch(loginComplete());
    }
  }, [dispatch, hasStoredUserMetadata]);
  useEffect(() => {
    if (!isAuthenticated || !isComplete) {
      return;
    }
    if (isIamFlow) {
      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Success',
        opt_label: 'username'
      });
    }
  }, [isAuthenticated, isComplete, isIamFlow]);
  const handleCloseMetadataErrorDialog = () => dispatch(loginComplete());
  const handleCloseErrorDialog = () => {
    dispatch(loginClearError());
    const params = new URLSearchParams(window.location.search);
    const rawReturnUrl = params.get('returnUrl') || '/';
    let returnUrl = '/';
    try {
      const resolved = new URL(rawReturnUrl, window.location.origin);
      if (resolved.origin === window.location.origin) {
        returnUrl = resolved.pathname + resolved.search + resolved.hash;
      }
    } catch {}
    window.location.assign(returnUrl);
  };
  useEffect(() => {
    if (!error) {
      return;
    }
    if (isIamErrorFlow) {
      const code = error.code || 665;
      logger.info(`category="IAM Users" action="IAM Login Failure" label="username" code="${code}"`);
    }
  }, [error, isIamErrorFlow]);
  return <Login error={error} hasMissingUserMetadata={Boolean(retailerInfoError) || isMissingUserMetadata} hasToChangePassword={hasToChangePassword} isAuthenticated={isAuthenticated} isComplete={isComplete} onCloseErrorDialog={handleCloseErrorDialog} onCloseMetadataErrorDialog={handleCloseMetadataErrorDialog} />;
};